import usePropertyService from 'api/services/propertyService'
import useWizardService from 'api/services/wizardService'
import Wizard from 'components/wizard/Wizard'
import { useTranslation } from 'react-i18next'
import { useQuery, useMutation } from 'react-query'
import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'

import { useAuth } from './authenticated/AuthContext'

interface PropertyResponse {
  success: boolean
  message?: string
  data?: any
}

const RegisterPropertyPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  
  const { loadRegisterPropertyQuickSteps, loadAuthRegisterPropertyQuickSteps } =
    useWizardService()
  const { registerProperty } = usePropertyService()
  const { isAuthenticated } = useAuth()

  const { data: listPropertySteps, isLoading: isStepsLoading } = useQuery(
    'listPropertySteps',
    () =>
      isAuthenticated
        ? loadAuthRegisterPropertyQuickSteps()
        : loadRegisterPropertyQuickSteps()
  )

  const { mutateAsync: registerPropertyMutation, isLoading: isRegistering } =
    useMutation<PropertyResponse, Error, any>(registerProperty)

  const handleClose = () => navigate('/')

  const handleSubmit = async (wizardValues: any) => {
    try {
      if (wizardValues.email) {
        localStorage.setItem('registrationEmail', wizardValues.email)
      }

      const response = await registerPropertyMutation(wizardValues)

      if (!response?.success) {
        throw new Error(response?.message || 'Failed to register property')
      }

      toast.success(
        t('messages.yourPropertyIsAlmostReady') as string
      )

      navigate(listPropertySteps.redirect)
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "We couldn't add your property. Please check and try again."

      toast.error(errorMessage)
    }
  }

  if (isStepsLoading) return null

  return (
    <Wizard
      isOpen
      setSubmit={handleSubmit}
      isLoading={isRegistering}
      wizardData={listPropertySteps}
      handleClose={handleClose}
    />
  )
}

export default RegisterPropertyPage
